window.$ = require('jquery');
window.bootstrap = require('bootstrap');

// window.aos = require('aos');
import {tns} from 'tiny-slider';
import ScrollMagic from 'scrollmagic';
import {jarallax} from "jarallax";

window.mapboxgl = require('mapbox-gl');

// csrf
$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

$(function() {
    $('p').each(function() {
        let text = $(this).html();
        text = text.replace(/(\s)([\S])[\s]+/g,"$1$2&nbsp;");
        text = text.replace(/(\s)([^<][\S]{1})[\s]+/g,"$1$2&nbsp;");
        $(this).html(text);
    });
});

// preloader
$(function() {
    $('#preloader').fadeOut();
});

// init
$(function () {
    scrollHeader($(window).scrollTop());

    $('.dynamic-label-form input, .dynamic-label-form textarea').each(function () {
        dynamicLabelForm($(this));
    })

    // aos.init({
    //     disable: 'mobile'
    // });
});

// cookies
let cookiesInfo = $('#cookies_info');
let acceptCookiesBtn = $('#accept_cookies');

function setAgreeCookie() {
    let expire = new Date();
    expire = new Date(expire.getTime() + (3600 * 1000) * 8750);
    document.cookie = "cookiesInfo=true; expires=" + expire;
}

if (document.cookie.indexOf("cookiesInfo=") >= 0) {
    $(cookiesInfo).addClass('hidden');
} else {
    $(cookiesInfo).removeClass('hidden');
}

$(acceptCookiesBtn).on('click', function (e) {
    e.preventDefault();
    setAgreeCookie();
    $(cookiesInfo).fadeOut('normal', function() {
        $(cookiesInfo).addClass('hidden');
    });
});

// tooltips
const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

// header
$(window).on('scroll', function () {
    scrollHeader($(window).scrollTop());
});

function scrollHeader(scroll) {
    const header = $('header');

    if (scroll > header.data('scroll_offset')) {
        header.addClass('scrolled');
    } else {
        header.removeClass('scrolled');
    }
}

$('.main-menu-toggle').on('click', function (e) {
    const header = $('header');
    const menu = $('#main_menu', header);

    $(this).stop();
    header.stop();
    menu.stop();

    if (header.hasClass('opened') || $(this).hasClass('is-active')) {
        $(this).removeClass('is-active');
        header.removeClass('opened');
        menu.fadeOut();
    } else {
        $(this).addClass('is-active');

        menu.fadeIn('normal', function () {
            header.addClass('opened');
        });
    }
});

// footer
$('#newsletter_form').on('submit', function (e) {
    e.preventDefault();

    const $form = $(this);

    $form.find('input').removeClass('is-invalid');

    $form.find('button').attr('disabled', 'disabled');

    $('.contact-form-message').fadeOut();

    $.ajax({
        url: $form.attr('action'),
        method: 'POST',
        dataType: 'JSON',
        data: $form.serialize(),
        success: function(response) {
            $form.find('input[type="text"]').val('');
            $form.find('button').removeAttr('disabled');
            $('.newsletter-message').html(response.message).fadeIn();
        },
        error: function (response) {
            if (response.status === 422) {
                const errors = response.responseJSON.errors;

                $.each(errors, function (field, error) {
                    const invalidInput = $('#newsletter_' + field ).addClass('is-invalid');
                    invalidInput.closest('.form-group').find('.invalid-feedback').html(error[0]);
                });
            } else {
                $('.newsletter-message').html(response.responseJSON.message).fadeIn();
            }

            $form.find('button').removeAttr('disabled');
        },
    });
});

// breadcrumbs
if ($('.breadcrumbs-section').length) {
    $(window).on('load', function () {
        function scrollRight(targetElement, speed) {
            const scrollWidth = $(targetElement).get(0).scrollWidth;
            const clientWidth = $(targetElement).get(0).clientWidth;
            $(targetElement).animate({scrollLeft: scrollWidth - clientWidth},
                {
                    duration: speed,
                });
        }

        scrollRight($('.breadcrumbs-section .breadcrumbs ul'), 250);
    });
}

// form
$('.dynamic-label-form input, .dynamic-label-form textarea').on('keyup change', function () {
    dynamicLabelForm($(this));
});

function dynamicLabelForm(input) {
    if (input.val().length > 0) {
        input.addClass('filled');
    } else {
        input.removeClass('filled');
    }
}

// HOME
if ($('.carousel-section').length) {
    tns({
        container: '.main-carousel',
        items: 1,
        controls: false,
        nav: true,
        navContainer: '.main-carousel-nav',
        gutter: 5,
        autoplay: true,
        autoplayButtonOutput: false,
    });

    function initTopSectionAnimation(controller) {
        new ScrollMagic
            .Scene({
                duration: 400,
                offset: 0,
            })
            .setPin('.carousel-section')
            .addTo(controller)
            .on("progress", function (e) {
                const progress = e.progress.toFixed(3);

                $('.main-content')
                    .css('transform', 'translateY(' + progress / 2 * 100 + 'px)');

                // $('.main-content > div .main-content-scroll-bg')
                //     .css('opacity', progress/1.6 );

                $('.main-signature-bg')
                    .css('transform', 'translateY(' + progress * 5 * -100 + 'px)')
                    .css('filter', 'grayscale(' + progress + ')');

                $('.main-carousel-shutter > div > div').css('width', (progress * 100) + '%');
                // $('.main-carousel-shutter > div > div').css('width', ((1 - progress) * 100) + '%');
            });
    }

    let controller = null;

    $(function() {
        toggleTopSectionAnimation();
    });

    $(window).on('resize', function() {
        toggleTopSectionAnimation();
    });

    function toggleTopSectionAnimation() {
        if (controller) {
            controller.destroy(true);
            controller = null;
        }

        if ($(window).width() > 991) {
            if (!controller) {
                controller = new ScrollMagic.Controller();
                initTopSectionAnimation(controller);
            }
        }
    }
}

$('.service-list-item').on('mouseover', function (e) {
    const serviceImage = $('.service-image');
    const imageUrl = $(this).data('image');

    serviceImage.attr('src', imageUrl);
});

// SERVICES
if ($('.service-image').length) {
    jarallax(document.querySelectorAll('.jarallax'), {
        speed: 0.2,
    });
}

// CONTACT
const mapContainer = $('.map-container');

if (mapContainer.length) {

    const
        lat = mapContainer.data('lat'),
        lng = mapContainer.data('lng');

    mapboxgl.accessToken = 'pk.eyJ1IjoicHJvamVjdGNvbSIsImEiOiJjam0zYWNtZGExMzhlM3BxZ21qdW50ZTZ5In0.DXybHncR274UuZ14L_ApdQ';
    let map = new mapboxgl.Map({
        container: "map",
        center: [lat, lng],
        zoom: 16,
        style: "mapbox://styles/projectcom/cla1hdj3u00hg14qt5i2xdpdm"
    });

    let size = 300;

    let pulsingDot = {
        width: size,
        height: size,
        data: new Uint8Array(size * size * 4),

        onAdd: function () {
            let canvas = document.createElement('canvas');
            canvas.width = this.width;
            canvas.height = this.height;
            this.context = canvas.getContext('2d');

            this.logo = new Image();
            this.logo.crossOrigin = "Anonymous";
            this.logo.src = '/img/logo_signet_white.svg';
        },

        render: function () {
            let duration = 1000;
            let t = (performance.now() % duration) / duration;

            let radius = (size / 2) * 0.3;
            let outerRadius = (size / 2) * 0.7 * t + radius;
            let context = this.context;

            context.clearRect(0, 0, this.width, this.height);
            context.beginPath();
            context.arc(
                this.width / 2,
                this.height / 2,
                outerRadius,
                0,
                Math.PI * 2
            );
            context.fillStyle = 'rgba(246, 75, 2, .1)' + (1 - t) + ')';
            context.fill();

            context.beginPath();
            context.arc(
                this.width / 2,
                this.height / 2,
                radius,
                0,
                Math.PI * 2
            );
            context.fillStyle = 'rgba(246, 75, 2, 1)';
            context.strokeStyle = 'white';
            context.lineWidth = 2 + 4 * (1 - t);
            context.fill();
            context.stroke();

            context.drawImage(
                this.logo,
                this.width / 2 - 24,
                this.height /2 - 30,
                48,
                60
            );

            this.data = context.getImageData(
                0,
                0,
                this.width,
                this.height
            ).data;

            map.triggerRepaint();

            return true;
        }
    };

    map.on('load', function () {
        map.addImage('pulsing-dot', pulsingDot, {pixelRatio: 2});

        map.addSource('points', {
            'type': 'geojson',
            'data': {
                'type': 'FeatureCollection',
                'features': [
                    {
                        'type': 'Feature',
                        'geometry': {
                            'type': 'Point',
                            'coordinates': [lat, lng]
                        }
                    }
                ]
            }
        });
        map.addLayer({
            'id': 'points',
            'type': 'symbol',
            'source': 'points',
            'layout': {
                'icon-image': 'pulsing-dot'
            }
        });
    });
}

const contactFormButton = $('#contact_submit_button');

contactFormButton.on('click', function (e) {
    e.preventDefault();

    const form = $('#contact_form');

    contactFormButton.attr('disabled', 'disabled');

    form.find('input').removeClass('is-invalid');
    form.find('select').removeClass('is-invalid');
    form.find('textarea').removeClass('is-invalid');

    $('.contact-form-message').fadeOut();

    $.post({
        url: form.attr('action'),
        dataType: 'JSON',
        data: form.serialize(),
        success: function (response) {
            form.find('input[type="text"]').val('');
            form.find('textarea').val('');
            contactFormButton.removeAttr('disabled');
            $('.contact-form-message').html(response.message).fadeIn();
        },
        error: function (response) {
            if (response.status === 422) {
                const errors = response.responseJSON.errors;

                $.each(errors, function (field, error) {
                    const invalidInput = $('#contact_form_' + field ).addClass('is-invalid');
                    invalidInput.closest('.form-group').find('.invalid-feedback').html(error[0]);
                });
            } else {
                $('.contact-form-message').html(response.responseJSON.message).fadeIn();
            }

            contactFormButton.removeAttr('disabled');
        }
    });
});

// BOOKING
const bookingSubmitButton = $('#booking_submit_button');

$('#booking_subject_id').on('change', function () {
    bigFamilyCardInput();
});

$(function() {
    bigFamilyCardInput();
});

function bigFamilyCardInput() {
    const selectedSubject = $('#booking_subject_id').find('option:selected');
    const bigFamilyCard = selectedSubject.data('big_family_card');

    if (bigFamilyCard) {
        $('.big-family-card-input').slideDown();
    } else {
        $('.big-family-card-input').slideUp();
    }
}

bookingSubmitButton.on('click', function (e) {
    e.preventDefault();

    const form = $('#booking_form');

    bookingSubmitButton.attr('disabled', 'disabled');

    form.find('input').removeClass('is-invalid');
    form.find('select').removeClass('is-invalid');
    form.find('textarea').removeClass('is-invalid');

    $('.booking-form-message').fadeOut();

    $.post({
        url: form.attr('action'),
        dataType: 'JSON',
        data: form.serialize(),
        success: function (response) {
            form.find('input:not([type="checkbox"])').val('');
            form.find('textarea').val('');

            $('.booking-form-message').html(response.message).fadeIn();

            form.find('input').removeClass('filled');
            form.find('textarea').removeClass('filled');

            bookingSubmitButton.removeAttr('disabled');
        },
        error: function (response) {
            if (response.status === 422) {
                const errors = response.responseJSON.errors;

                $.each(errors, function (field, error) {
                    const invalidInput = $('#booking_' + field ).addClass('is-invalid');
                    invalidInput.closest('.form-group').find('.invalid-feedback').html(error[0]);
                });
            } else {
                $('.booking-form-message').html(response.responseJSON.message).fadeIn();
            }

            bookingSubmitButton.removeAttr('disabled');
        }
    });
});

$('input[name="document_type"]').on('change', function() {
    const val = $(this).val();

    if (val === 'invoice') {
        $('.invoice-data').slideDown();
    } else {
        $('.invoice-data').slideUp();
    }
});

const payButton = $('#pay_button');

$('#booking_pay_form').on('submit', function (e) {
    e.preventDefault();

    payButton.attr('disabled', 'disabled');

    const form = $(this);

    form.find('input').removeClass('is-invalid');
    $('.pay-form-error').slideUp();

    $.ajax({
        url: form.attr('action'),
        method: 'POST',
        data: form.serialize(),
        dataType: 'JSON',
        success: function (response) {
            window.location.replace(response.redirect);
        },
        error: function (response) {
            if (response.status === 422) {
                const errors = response.responseJSON.errors;

                $.each(errors, function (field, error) {
                    const invalidInput = $('#' + field ).addClass('is-invalid');
                    invalidInput.closest('.form-group').find('.invalid-feedback').html(error[0]);
                });
            } else {
                $('.pay-form-error').html(response.responseJSON.error).slideDown();
            }

            payButton.removeAttr('disabled');
        },
    });
});
